import { Loader, Logo } from "@/components/lib";
import PlayerCard from "./playerCard";
import PlayerFilters from "@/views/players/playerFilters";
import { usePlayers } from "@/views/players/usePlayers";
import Style from "@/css/mainStyles";

export default function Players() {
  const {
    players,
    loadingPlayers,
    setSearch,
    setPosition,
    setPlayerClass,
    limit,
    setLimit
  } = usePlayers();

  return (
    <main className="flex flex-col text-center text-white">
      <Logo className="w-48 lg:w-64 mx-auto my-5 sm:mt-0 lg:hidden" />

      <PlayerFilters
        setSearchResults={setSearch}
        setPlayerClass={setPlayerClass}
        setPosition={setPosition}
        className="flex gap-2 justify-between items-center px-2 sm:justify-center w-full text-[#A2A5A9] mb-4 lg:mx-auto lg:text-xl"
      />

      {loadingPlayers ? (
        <div className="flex justify-center items-center py-10">
          <Loader />
        </div>
      ) : players.length > 0 ? (
        <div className="mt-5 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {players.map((player: any) => (
            <PlayerCard player={player} key={player.id} />
          ))}
          {players.length === limit && (
            <button
              type="button"
              onClick={() => setLimit(limit + 50)}
              className={"col-span-full " + Style.blueButton}
            >
              Load More
            </button>
          )}
        </div>
      ) : (
        <p className="text-center text-2xl">No players found</p>
      )}
    </main>
  );
}
